module.exports = __webpack_public_path__ + "static/1000-front-on-021958a2d5694db31836c70471a031aa.jpg";